
export class ItemStateModel {
    totalDocCount: number;
}